import './Navbar.css';
import {Link} from 'react-router-dom';

const Navbar = () => {
  return (
    <div className="navbar">
      <Link exact to="/public-api/">
        <h1>Public API</h1>
      </Link>
      <ul>
        <li><Link to="/public-api/"><button>Home</button></Link></li>
        <li><Link to="/public-api/categories"><button>Categories</button></Link></li>
        <li><Link to="/public-api/random"><button>Random</button></Link></li>
      </ul>
    </div>
  )
}

export default Navbar;
